import {useInfiniteQuery, useQuery} from 'react-query';
import {getListContractedStore} from './getListContractedStore';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';

const useGetListContractedStore = (stateId: string) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['list-contracted-store', stateId],
    async ({pageParam = 1}) => getListContractedStore({pageParam, stateId}),
    {
      enabled: Boolean(stateId),
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetListContractedStore;
